module.exports = __webpack_public_path__ + "static/img/22.83638bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/22.png
// module id = VwOe
// module chunks = 0